define('modules/editor/views/elements/button',['require','exports','module','./element','ldsh!../../templates/elements/button'],function(require, exports, module) {
  "use strict";
  var Element = require("./element");

  module.exports = Element.extend({
    template: require("ldsh!../../templates/elements/button"),
    className: "ed-panel-item ed-item-button",

    events: _.extend(Element.prototype.events, {
      "click .btn": "preventDefault"
    }),

    preventDefault: function(e) {
      e.preventDefault();
      e.stopPropagation();

      return false;
    }
  });
});

